export const USER_ID_COOKIE_NAME = 'user_id';
